const AmberCopilotLogoSvg = ({ width = 21, height = 21 }: { width?: number; height?: number }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 616 600"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2926_1929)">
      <mask
        id="mask0_2926_1929"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="600"
        height="600"
      >
        <path d="M0 0H599.441V599.441H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2926_1929)">
        <mask
          id="mask1_2926_1929"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="600"
          height="600"
        >
          <path
            d="M194.8 8.99377C194.8 4.0274 190.772 -0.0188283 185.812 0.211956C135.755 2.52859 88.5168 24.0439 53.9126 60.2866C19.3084 96.5294 0 144.712 0 194.822C0 244.932 19.3084 293.115 53.9126 329.357C88.5168 365.6 135.755 387.115 185.812 389.432C190.772 389.66 194.8 385.613 194.8 380.647V8.99377ZM590.431 194.82C595.398 194.82 599.444 190.792 599.216 185.832C596.979 137.322 576.702 91.3983 542.362 57.0629C515.117 29.8157 480.404 11.2602 442.613 3.7431C404.822 -3.77397 365.65 0.0851347 330.052 14.8323C306.415 24.6217 284.937 38.9716 266.847 57.0624C248.756 75.1533 234.406 96.6306 224.616 120.268C215.983 141.11 211.035 163.293 209.993 185.829C209.765 190.792 213.811 194.82 218.778 194.82H590.431ZM404.605 590.451C404.605 595.418 408.633 599.464 413.593 599.236C436.13 598.196 458.314 593.248 479.157 584.613C502.795 574.825 524.273 560.475 542.364 542.384C560.455 524.293 574.804 502.815 584.593 479.177C594.385 455.542 599.424 430.208 599.424 404.625C599.424 379.041 594.385 353.708 584.593 330.072C574.805 306.434 560.456 284.956 542.365 266.865C524.274 248.774 502.795 234.424 479.157 224.637C458.314 216.002 436.13 211.054 413.593 210.013C408.633 209.785 404.605 213.832 404.605 218.798V590.451ZM8.97356 404.625C4.00719 404.625 -0.0390358 408.653 0.191749 413.613C2.4298 462.122 22.7049 508.046 57.0427 542.382C75.132 560.475 96.6084 574.826 120.245 584.616C143.882 594.407 169.216 599.445 194.8 599.443C220.384 599.444 245.718 594.406 269.355 584.615C292.991 574.825 314.468 560.474 332.558 542.382C350.649 524.292 364.999 502.815 374.788 479.177C383.423 458.334 388.371 436.15 389.412 413.613C389.639 408.653 385.593 404.625 380.627 404.625H8.97356Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_2926_1929)">
          <path d="M599.441 0H0V599.441H599.441V0Z" fill="white" />
          <path d="M599.441 0H0V599.441H599.441V0Z" fill="#FFC700" fillOpacity="0.331" />
          <g filter="url(#filter0_f_2926_1929)">
            <path d="M617.495 248.428H159.672V610.341H617.495V248.428Z" fill="#FFC700" />
            <path d="M443.67 50.9536H45.0415V404.624H443.67V50.9536Z" fill="#C41B21" />
            <path d="M665.496 47.9473H350.79V503.522H665.496V47.9473Z" fill="#FF33B1" />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_2926_1929"
        x="-142.284"
        y="-139.378"
        width="995.105"
        height="937.044"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="93.6626" result="effect1_foregroundBlur_2926_1929" />
      </filter>
      <clipPath id="clip0_2926_1929">
        <rect width="616" height="599.441" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default AmberCopilotLogoSvg;
